import React from "react";
import "../styles/Marquee.css"

const MarqueeExample = ({message= "Welcome to MdMall.in! A business initiative to fulfill your business needs at your doorstep."}) =>{
  return (
    <div className="marquee-container d-flex align-center w-100">
      <div className="marquee-content">
        {message}
      </div>
    </div>
  );
};

export default MarqueeExample;
